// src/pages/Documentation.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon, BookOpenIcon, CodeBracketIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import SEO from '../components/SEO';

export function Documentation() {
    return (
        <>
            <SEO
                title="Documentation - PostMgr API and User Guide"
                description="Complete documentation for PostMgr including API reference, user guides, and integration tutorials."
                url="https://postmgr.com/docs"
            />

            <div className="min-h-screen bg-gray-50">
                <nav className="bg-white shadow-sm">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between h-16">
                            <div className="flex items-center">
                                <Link to="/" className="flex items-center">
                                    <img src="/images/Bob_only.svg" alt="PostMgr" className="h-8 w-8" />
                                    <span className="ml-2 text-2xl font-bold text-blue-600">PostMgr</span>
                                </Link>
                            </div>
                            <div className="flex items-center space-x-4">
                                <Link to="/login" className="text-gray-700 hover:text-blue-600">Sign In</Link>
                                <Link to="/register" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">Get Started</Link>
                            </div>
                        </div>
                    </div>
                </nav>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">Documentation</h1>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                            Everything you need to know about using PostMgr and integrating with our API
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="bg-white rounded-lg shadow-sm p-6">
                            <BookOpenIcon className="h-12 w-12 text-blue-600 mb-4" />
                            <h3 className="text-xl font-semibold text-gray-900 mb-3">User Guide</h3>
                            <p className="text-gray-600 mb-4">Learn how to use PostMgr's features to automate your social media management.</p>
                            <Link to="/docs/user-guide" className="text-blue-600 hover:text-blue-700 font-medium">Read Guide →</Link>
                        </div>

                        <div className="bg-white rounded-lg shadow-sm p-6">
                            <CodeBracketIcon className="h-12 w-12 text-green-600 mb-4" />
                            <h3 className="text-xl font-semibold text-gray-900 mb-3">API Reference</h3>
                            <p className="text-gray-600 mb-4">Complete API documentation with examples and code snippets.</p>
                            <Link to="/docs/api" className="text-blue-600 hover:text-blue-700 font-medium">View API →</Link>
                        </div>

                        <div className="bg-white rounded-lg shadow-sm p-6">
                            <RocketLaunchIcon className="h-12 w-12 text-purple-600 mb-4" />
                            <h3 className="text-xl font-semibold text-gray-900 mb-3">Getting Started</h3>
                            <p className="text-gray-600 mb-4">Quick setup guide to get you up and running in minutes.</p>
                            <Link to="/docs/getting-started" className="text-blue-600 hover:text-blue-700 font-medium">Get Started →</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Documentation;